import React from 'react';

function weekdayDe(date: Date) {
    return date.toLocaleDateString('de-DE', { weekday: 'long' });
}

function dateDe(date: Date) {
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

interface KioskHeaderProps {
    logoUrl?: string;
    currentDate: Date;
}

export const KioskHeader: React.FC<KioskHeaderProps> = ({ logoUrl, currentDate }) => {
    return (
        <div className="bg-slate-50 border-2 border-slate-200 rounded-xl p-3 shadow-sm text-center shrink-0">
            {logoUrl && (
                <img src={logoUrl} alt="Logo" className="h-12 w-auto mx-auto mb-2" />
            )}
            <h1 className="kiosk-text-xl font-black tracking-tight text-slate-900 uppercase leading-none mb-1">Vertretungsplan</h1>
            <div className="text-slate-700 kiosk-text-base font-bold">
                {weekdayDe(currentDate)}
            </div>
            <div className="text-slate-500 font-medium kiosk-text-sm">
                {dateDe(currentDate)}
            </div>
            <div className="mt-2 pt-2 border-t border-slate-200 kiosk-text-2xs text-slate-400 font-mono">
                <div>Aktualisiert: {new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}</div>
            </div>
        </div>
    );
};
